import React, { useContext, useEffect, useState } from 'react';
import UserContext from '@/context/UserContext';
import { isJaguar } from '@/utility/UserUtils';
import { format } from 'date-fns';
import { fetchAPI } from '@/utility/NetworkUtils';
const ItemUpdatedAtComponent = ({item}) => {
  const { user } = React.useContext(UserContext);
  const [ createdBy, setCreatedBy ] = useState(null);
  const [ updatedBy, setUpdatedBy ] = useState(null);
  const [ loading, setLoading ] = useState(true);
  const fetchWhodunnit = () => {
    setLoading(true)
    fetchAPI(`/webapi/items/${item.id}/whodunnit`, (json) => {
      setLoading(false)
      if (!json.error) {
        setUpdatedBy(json.updated_by)
        setCreatedBy(json.created_by)
      } else {

      }
    })
  }

  useEffect(() => {
    if(isJaguar(user)){
      fetchWhodunnit()
    }
  }, [user, item.id]);

  const renderUser = (renderingUser) => {
    if(loading) {
      return "[Loading...]"
    }
    else if(renderingUser) {
      return `${renderingUser.first_name} ${renderingUser.last_name}`
    }else {
      return "[Unknown]"
    }
  }
  if(isJaguar(user)){
    return (
      <div className="quickview-additional-info align-baseline mt-auto mb-[11px]">
        Item#: {item.id}
        <br/>
        Created by: {renderUser(createdBy)}, {format(new Date(item.created_at), "MM/dd/yyyy, h:mm a")}
        <br/>
        Updated by: {renderUser(updatedBy)}, {format(new Date(item.updated_at), "MM/dd/yyyy, h:mm a")}
      </div>
    )
  }
}
export default ItemUpdatedAtComponent